import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'reactstrap';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { default as DataWidget } from '../DataWidget/';
import { default as DoughnutChart } from '../Chart/doughnut';
import { default as SelectModal } from '../Select/modal';
import { SECTIONS_TITLES } from 'containers/Admin/constants';
import reducer from './reducer';
import saga from './saga';
import { getAgent } from './actions';
import { makeSelectAgent } from './selectors';
import { makeSelectModalOption } from '../Select/selectors';
import { featureAllowed } from 'containers/App/selectors';
import './styles.scss';

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { code, interval } = this.props;
    this.props.loadAgent(code, interval);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { code, interval } = this.props;
    if (prevProps.interval !== interval && interval !== 'undefined') {
      this.props.loadAgent(code, interval);
    }
  }

  render() {
    const { agent, featureAllowed } = this.props;

    const data = [agent.open, agent.lost, agent.won];
    const labels = [
      { color: '#047bf8', label: 'In corso' },
      { color: '#e65252', label: 'Persi' },
      { color: '#85c751', label: 'Vinti' },
    ];

    return (
      <>
        <SelectModal selectedRange={agent.selectedRange || ''} />
        <Row>
          <Col md={4}>
            <DataWidget
              title={SECTIONS_TITLES.ADMIN_WIDGET_TOTAL_QUOTES}
              value={agent.won}
              unit=""
              size={12}
            />
            {featureAllowed('fees-visibility') &&
              <DataWidget
                title={SECTIONS_TITLES.ADMIN_WIDGET_EFFECTIVE_PROFITS}
                value={agent.effective_profit}
                oldValue={agent.previous_effective_profit}
                size={12}
              />
            }
            <DataWidget
              title={SECTIONS_TITLES.ADMIN_WIDGET_NEW_CUSTOMERS}
              value={agent.new_customers}
              unit=""
              size={12}
            />
          </Col>
          <Col md={8}>
            <DoughnutChart
              data={data}
              labels={labels}
              title={SECTIONS_TITLES.DASHBOARD_DOUGHNUT_CHART_TITLE}
              height={110}
            />
          </Col>
        </Row>
      </>
    );
  }
}

Details.defaultProps = {};

Details.propTypes = {
  code: PropTypes.number.isRequired,
  loadAgent: PropTypes.func.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    loadAgent: code => dispatch(getAgent(code)),
  };
}

const mapStateToProps = createStructuredSelector({
  agent: makeSelectAgent(),
  interval: makeSelectModalOption(),
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
});

const withReducer = injectReducer({ key: 'agent', reducer });
const withSaga = injectSaga({ key: 'agent', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(Details);
